import { memberGroup as base } from './memberGroup';

export const memberGroup = { ...base };
